


  
  

  var faAvancar10s = {
    prefix: 'fak',
    iconName: 'avancar-10s',
    icon: [
      512,
      512,
      [],
      'e00e',
      
      'M430.7 250.7c-2.1-9.6-13.9-12.3-20.8-5.4c-3.4 3.4-4.6 8.3-3.7 13c10.6 49.3-3.4 102.7-41.6 141c-60 60-157.3 60-217.3 0s-60-157.3 0-217.3c40.2-40.2 97.1-53.4 148.3-39.8l-48.8 48.8c-5 5-5 13.1 0 18.1s13.1 5 18.1 0l72.5-72.5c5-5 5-13.1 0-18.1L265 45.9c-5-5-13.1-5-18.1 0s-5 13.1 0 18.1l52.3 52.3c-59-14.7-124 1.1-170.1 47.2C59.2 233.4 59.2 347 129.1 417s183.5 69.9 253.4 0c45.1-45.1 61.3-108.5 48-166.6l.2 .3zM190.1 335.2c-5.9 0-10.7 4.8-10.7 10.9s4.8 10.7 10.7 10.7h48c5.9 0 10.7-4.8 10.7-10.7s-4.8-10.9-10.7-10.9H224.8V262.1c0-3.7-1.8-7-4.6-8.8c0 0-.5-.3-.6-.5c-3.4-1.9-7.4-1.9-10.7 0l-21 12c-5.1 3-7 9.6-4 14.7s9.6 7 14.7 4l4.8-2.7v54.6H190.1v-.2zM252.5 292v24c0 22.6 18.2 40.8 40.8 40.8s40.8-18.2 40.8-40.8V292c0-22.6-18.2-40.8-40.8-40.8s-40.8 18.2-40.8 40.8zm60 0v24c0 10.6-8.6 19.2-19.2 19.2s-19.2-8.6-19.2-19.2V292c0-10.6 8.6-19.2 19.2-19.2s19.2 8.6 19.2 19.2z'
      
    ]
  };

  

  
  

  var faFacebookF = {
    prefix: 'fak',
    iconName: 'facebook-f',
    icon: [
      512,
      512,
      [],
      'e000',
      
      'M364.1 284L377 202.9H296.4V150.3c0-22.2 11.3-43.8 47.4-43.8h36.7v-69s-33.3-5.5-65.1-5.5c-66.5 0-109.9 38.8-109.9 109.1v61.8H131.6V284h73.9V480h90.9V284h67.8z'
      
    ]
  };

  

  
  

  var faHorizontal = {
    prefix: 'fak',
    iconName: 'horizontal',
    icon: [
      512,
      512,
      [],
      'e00b',
      
      'M432 336c0 8.8-7.2 16-16 16L96 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 160zm48-160c0-35.3-28.7-64-64-64L96 112c-35.3 0-64 28.7-64 64l0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160z'
      
    ]
  };

  

  
  

  var faInstagram = {
    prefix: 'fak',
    iconName: 'instagram',
    icon: [
      512,
      512,
      [],
      'e006',
      
      'M256 141.1A114.9 114.9 0 1 0 256 370.9a114.9 114.9 0 1 0 .1-229.7zm-.1 40.2a74.7 74.7 0 1 1 .1 149.4A74.7 74.7 0 1 1 256 181.3zm92.9-44.9a26.8 26.8 0 1 1 53.6 0 26.8 26.8 0 1 1 -53.6 0zm129.6 27.2c-1.7-35.9-9.9-67.7-36.2-93.9c-26.2-26.2-58-34.4-93.8-36.2c-37-2.1-147.8-2.1-184.8 0C127.8 35.3 96 43.5 69.8 69.7s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.8c1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.8 36.2c37 2.1 147.8 2.1 184.8 0c35.9-1.7 67.7-9.9 93.8-36.2c26.2-26.2 34.4-58 36.2-93.9c2.1-37 2.1-147.7 0-184.7zM430.7 388.1c-7.8 19.6-22.9 34.7-42.6 42.6c-29.5 11.7-99.4 9-132 9s-102.6 2.6-132-9c-19.6-7.8-34.7-22.9-42.6-42.6c-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6c29.5-11.7 99.4-9 132-9s102.6-2.6 132 9c19.6 7.8 34.7 22.9 42.6 42.6c11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z'
      
    ]
  };

  

  
  

  var faInstagramSolid = {
    prefix: 'fak',
    iconName: 'instagram-solid',
    icon: [
      512,
      512,
      [],
      'e001',
      
      'M478.6 164.2c-.3-18.8-3.8-37.5-10.4-55c-11.7-30-35.4-53.8-65.5-65.4c-17.4-6.5-35.8-10-54.4-10.4C324.3 32.3 316.7 32 256 32s-68.5 0-92.3 1.4c-18.6 .4-37 3.9-54.4 10.4C79.2 55.4 55.5 79.2 43.8 109.2c-6.5 17.4-10.1 35.7-10.4 54.3C32.3 187.4 32 195 32 255.6s0 68.4 1.4 92.1c.4 18.6 3.9 36.9 10.4 54.3c11.7 30 35.4 53.7 65.5 65.4c17.3 6.8 35.7 10.6 54.4 11.2c24 1.1 31.5 1.4 92.3 1.4s68.5 0 92.3-1.4c18.6-.4 37-3.9 54.4-10.4c30.1-11.6 53.8-35.4 65.5-65.4c6.5-17.4 10.1-35.7 10.4-54.3c1.1-23.9 1.4-31.5 1.4-92.1c-.1-60.7-.1-68.4-1.4-92.1zM256.2 141.7a114.3 114.3 0 1 1 -.3 228.6 114.3 114.3 0 1 1 .3-228.6zm119.2-32.1a26.8 26.8 0 1 1 0 53.5 26.8 26.8 0 1 1 0-53.5zM256 330.6a74.6 74.6 0 1 0 0-149.2 74.6 74.6 0 1 0 0 149.2z'
      
    ]
  };

  

  
  

  var faLinkedinSolid = {
    prefix: 'fak',
    iconName: 'linkedin-solid',
    icon: [
      512,
      512,
      [],
      'e004',
      
      'M46.7 55.3c-31.3 31.3-9.2 84.5 35.1 84.5c44 0 67.5-56.5 36-86.2c-19-17.8-52.4-17.1-71.1 1.6zM323.1 175.2c-8 3.4-20.4 11.6-27.6 18.4l-13.1 12.3 0-15.5 0-15.5-46.5 0-46.5 0 0 148.2 0 148.2 45.7 0 45.7 0 2.7-91.6c2.9-99.1 6.6-112.3 34.9-124c21.2-8.8 43-2.7 54.7 15.3c7.5 11.4 10.2 34.8 12.5 107.4l3 92.9 45.7 0 45.7 0 0-112.1c0-104.8-.9-113.8-13.1-137.7c-19.7-38.5-37.9-49.1-87.5-50.8c-23-.8-48.4 1.3-56.4 4.6zM32.4 323l0 148.2 49.4 0 49.4 0 0-148.2 0-148.2-49.4 0-49.4 0 0 148.2z'
      
    ]
  };

  

  
  

  var faLogoHero = {
    prefix: 'fak',
    iconName: 'logo-hero',
    icon: [
      512,
      512,
      [],
      'e009',
      
      'M307.3 219.4l0-187.4 81.1 0 0 366.9-81.1 0 0-100.1 31.4-1.9-201.3 0L55.9 220l81.5-.7 0-105.7 80.3 0 0 105.8 89.6 0zM137.4 480l0-170.8 80.3-4.9 0 175.7-80.3 0z'
      
    ]
  };

  

  
  

  var faPictureInPicture = {
    prefix: 'fak',
    iconName: 'picture-in-picture',
    icon: [
      512,
      512,
      [],
      'e00f',
      
      'M218.7 353.1c0 8.8 7.2 16 16 16H401.8c8.8 0 16-7.2 16-16V242c0-8.8-7.2-16-16-16H234.7c-8.8 0-16 7.2-16 16V353.1zM72.2 432c-11.5 0-21-3.9-28.7-11.6S32 403 32 391.4V120.6c0-11.6 3.8-21.2 11.5-29S60.8 80 72.2 80H439.8c11.5 0 21 3.9 28.7 11.6s11.5 17.4 11.5 29V391.4c0 11.6-3.8 21.2-11.5 29s-17.2 11.6-28.7 11.6H72.2zm0-25.1H439.8c3.8 0 7.3-1.6 10.5-4.8s4.8-6.8 4.8-10.6V120.6c0-3.9-1.6-7.4-4.8-10.6s-6.7-4.8-10.5-4.8H72.2c-3.8 0-7.3 1.6-10.5 4.8s-4.8 6.8-4.8 10.6V391.4c0 3.9 1.6 7.4 4.8 10.6s6.7 4.8 10.5 4.8z'
      
    ]
  };

  

  
  

  var faTiktokSolid = {
    prefix: 'fak',
    iconName: 'tiktok-solid',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M444.5 137.5c-2.3-2.3-4.7-2.3-9.4-2.3c-7 0-11.7 0-18.8-2.3c-39.9-9.4-68-39.9-70.4-79.7V43.7c0-7-4.7-11.7-11.7-11.7H261.5c-7 0-11.7 4.7-11.7 11.7V336.9c0 28.1-23.5 49.3-49.3 49.3c-16.4 0-30.5-7-39.9-18.8c-16.4-21.1-11.7-53.9 9.4-70.4c9.4-7 18.8-7 37.5-7c2.3 0 7 0 9.4-2.3s4.7-4.7 4.7-9.4V200.9c0-4.7-4.7-11.7-9.4-11.7c-37.5-4.7-75.1 4.7-103.2 28.1c-25.8 23.5-44.6 56.3-49.3 96.2c-7 44.6 9.4 91.5 39.9 122c28.1 30.5 68 44.6 105.5 44.6s75.1-14.1 103.2-42.2s44.6-65.7 44.6-105.5v-129c28.1 14.1 58.6 23.5 89.1 23.5c7 0 11.7-4.7 11.7-11.7V144.6c-4.7-2.3-7-4.7-9.4-7z'
      
    ]
  };

  

  
  

  var faTwitterSolid = {
    prefix: 'fak',
    iconName: 'twitter-solid',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M32.2 57.7c2.2 5.6 63 91 149.2 209.7l10.3 14.1-74.8 84.7c-41.1 46.6-76.3 87-78.1 89.9c-2 3.1 9.8 5.2 29.3 5.2l32.7 0 58.1-67.3c32-37 59.7-67.4 61.5-67.5s25.2 30.1 51.9 67.3l48.5 67.5 80.9 0c64.3 0 80.3-1.4 78.1-7.1c-1.5-3.9-35.2-51.9-74.8-106.7s-76.4-106.3-81.8-114.4l-9.8-14.7 70.1-79.4c38.6-43.7 70.1-81.4 70.1-83.9s-13.3-4.5-29.7-4.5l-29.7 0L342.9 110c-28.3 32.6-53.6 60.7-56.3 62.3s-25.3-25.1-50.1-59.3L191.2 50.7l-80.9 0c-64.2 0-80.3 1.5-78.1 7zm101.5 56.1L123.4 98.5l21.4 1.7C166.1 102 166.9 103 277.1 256L388 410l-18.1 1.8c-10 1-21.2-1.4-25.1-5.4c-6.5-6.7-188.5-258.7-211.2-292.6z'
      
    ]
  };

  

  
  

  var faVertical = {
    prefix: 'fak',
    iconName: 'vertical',
    icon: [
      512,
      512,
      [],
      'e00a',
      
      'M176 432c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-160 0zm160 48c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L176 32c-35.3 0-64 28.7-64 64l0 320c0 35.3 28.7 64 64 64l160 0z'
      
    ]
  };

  

  
  

  var faVideoSpeed = {
    prefix: 'fak',
    iconName: 'video-speed',
    icon: [
      512,
      512,
      [],
      'e010',
      
      'M86 373.6c3.9 5.6 11.9 6 16.7 1.2c4-4 4.4-10.4 1.1-15.1c-7.2-10.3-13.2-21.4-18-33.3c-4.9-12-8.5-24.5-10.9-37.6c-1.1-5.7-5.9-10-11.7-10c-6.9 0-12.3 6-11.2 12.8c2.6 15.2 6.5 29.3 11.9 42.3c5.4 13.2 12.8 26.4 22.1 39.7zM52.1 220.3c-1.2 6.8 4.2 12.9 11.1 12.9c5.8 0 10.6-4.3 11.7-9.9c2.4-13.1 6.1-25.6 10.9-37.5c4.8-11.7 10.8-22.8 18-33.1c3.3-4.7 2.9-11.1-1.1-15.1c-4.8-4.8-12.8-4.3-16.7 1.2c-9.3 13.2-16.6 26.4-22 39.4c-5.3 12.9-9.3 26.9-11.9 42zM217.8 458c6.7 1.3 12.8-4 12.8-10.9c0-5.6-4.2-10.4-9.7-11.4c-13.4-2.5-26.2-6.4-38.2-11.8c-11.8-5.2-22.7-11.3-32.9-18.4c-4.7-3.3-11.1-2.8-15.1 1.2c-4.8 4.9-4.2 12.9 1.5 16.8c13.1 8.9 25.8 16.1 38.1 21.5c12.5 5.5 27 9.8 43.6 12.9zM135.7 104.8c4.1 4.1 10.5 4.4 15.2 1.1c10.1-7 21-13 32.7-18.1c12.1-5.2 24.9-9.1 38.4-11.6c5.5-1 9.7-5.8 9.7-11.4c0-6.8-6.1-12.1-12.8-10.9c-16.7 3.1-31.3 7.3-43.8 12.7c-12.3 5.3-25 12.3-38 21.2c-5.7 3.9-6.3 12-1.4 16.9zM277.4 447.3c0 6.8 5.9 12.2 12.7 11.1c46.8-7.6 86-29.3 117.8-65c34.6-38.9 51.9-84.7 51.9-137.4s-17.3-98.6-51.9-137.4c-31.8-35.7-71.1-57.3-117.8-65c-6.7-1.1-12.7 4.3-12.7 11.1c0 5.7 4.2 10.6 9.9 11.6c41.6 7.9 76.4 27.7 104.4 59.4C421.9 169.9 437 210 437 256s-15.1 86.1-45.3 120.3c-28 31.7-62.8 51.5-104.4 59.4c-5.6 1.1-9.9 5.9-9.9 11.6zM220.3 169.9c-5.9-3.6-13.4-3.8-19.4-.4s-9.8 9.8-9.8 16.7L191 327c0 7 3.8 13.4 9.8 16.7s13.4 3.3 19.4-.4l115.2-70.4c5.7-3.5 9.2-9.7 9.2-16.4s-3.5-12.9-9.2-16.4L220.3 169.7l0 .2z'
      
    ]
  };

  

  
  

  var faVoltar10s = {
    prefix: 'fak',
    iconName: 'voltar-10s',
    icon: [
      512,
      512,
      [],
      'e00c',
      
      'M382.7 163.6c-46.1-46.1-111-61.8-170.1-47.2L265 64c5-5 5-13.1 0-18.1s-13.1-5-18.1 0l-72.5 72.5c-5 5-5 13.1 0 18.1L246.9 209c5 5 13.1 5 18.1 0s5-13.1 0-18.1l-48.8-48.8c51.2-13.8 108.2-.5 148.3 39.8c60 60 60 157.3 0 217.3s-157.3 60-217.3 0C109 361 95 307.6 105.6 258.3c1-4.6-.3-9.6-3.7-13c-6.9-6.9-18.7-4.3-20.8 5.4C68 308.8 84 372.2 129.1 417.3c69.9 69.9 183.5 69.9 253.4 0s69.9-183.5 0-253.4l.2-.3zM190.1 335.2c-5.9 0-10.7 4.8-10.7 10.7s4.8 10.7 10.7 10.7h48c5.9 0 10.7-4.8 10.7-10.7s-4.8-10.7-10.7-10.7H224.8V261.9c0-3.8-2.1-7.2-5.1-9.1c0 0 0 0 0-.2c-3.4-1.9-7.4-1.9-10.7 0l-21 12c-5.1 2.9-7 9.4-4 14.7c2.9 5.1 9.4 7 14.7 4l4.8-2.7v54.6H190.2h-.2zm103.2 21.6c22.6 0 40.8-18.2 40.8-40.8V292c0-22.6-18.2-40.8-40.8-40.8s-40.8 18.2-40.8 40.8v24c0 22.6 18.2 40.8 40.8 40.8zM273.9 292c0-10.6 8.6-19.2 19.2-19.2s19.2 8.6 19.2 19.2v24c0 10.6-8.6 19.2-19.2 19.2s-19.2-8.6-19.2-19.2V292z'
      
    ]
  };

  

  
  

  var faWhatsapp = {
    prefix: 'fak',
    iconName: 'whatsapp',
    icon: [
      544,
      512,
      [],
      'e005',
      
      'M425.7 97.1C383.8 55.1 328 32 268.7 32c-122.4 0-222 99.6-222 222c0 39.1 10.2 77.3 29.6 111L44.8 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222c0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4L98.2 427.3l18.6-68.1-4.4-7C93.9 322.8 84.2 288.9 84.2 254C84.2 152.3 167 69.5 268.8 69.5c49.3 0 95.6 19.2 130.4 54.1s56.2 81.2 56.1 130.5c0 101.8-84.9 184.6-186.6 184.6zM369.9 300.5c-5.5-2.8-32.8-16.2-37.9-18c-5.1-1.9-8.8-2.8-12.5 2.8s-14.3 18-17.6 21.8c-3.2 3.7-6.5 4.2-12 1.4c-32.6-16.3-54-29.1-75.5-66c-5.7-9.8 5.7-9.1 16.3-30.3c1.8-3.7 .9-6.9-.5-9.7s-12.5-30.1-17.1-41.2c-4.5-10.8-9.1-9.3-12.5-9.5c-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.6 57.4c2.8 3.7 39.1 59.7 94.8 83.8c35.2 15.2 49 16.5 66.6 13.9c10.7-1.6 32.8-13.4 37.4-26.4s4.6-24.1 3.2-26.4c-1.3-2.5-5-3.9-10.5-6.6z'
      
    ]
  };

  

  
  

  var faWhatsappSolid = {
    prefix: 'fak',
    iconName: 'whatsapp-solid',
    icon: [
      512,
      512,
      [],
      'e007',
      
      'M32.1 480L62.4 368.7C42.4 334.5 31.9 295.6 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224s-100.3 224-224 224c-39.6 .1-78.5-10.4-112.7-30.4L32.1 480zM175.2 150.9c-2.9 .2-5.7 .9-8.3 2.2c-2.4 1.4-4.6 3.1-6.6 5.1c-2.7 2.5-4.2 4.7-5.8 6.9c-8.3 10.8-12.7 24-12.7 37.6c0 11 2.9 21.7 7.4 31.7c9.2 20.2 24.2 41.6 44.2 61.4c4.8 4.8 9.5 9.6 14.5 14c24.7 21.8 54.2 37.5 86 45.8l12.7 1.9c4.1 .2 8.3-.1 12.5-.3c6.5-.3 12.9-2.1 18.7-5.2c3.7-2 5.5-3 8.6-4.9c0 0 1-.6 2.8-2c3-2.2 4.9-3.8 7.4-6.5c1.9-1.9 3.5-4.2 4.7-6.8c1.7-3.7 3.5-10.6 4.2-16.4c.5-4.4 .4-6.9 .3-8.4c-.1-2.4-2.1-4.9-4.3-5.9l-13-5.8s-19.5-8.5-31.4-13.9c-1.3-.5-2.6-.9-4-.9c-1.5-.2-3.1 0-4.5 .5s-2.8 1.3-3.9 2.3v0c-.1 0-1.6 1.3-17.8 20.9c-.9 1.2-2.2 2.2-3.7 2.7s-3.1 .6-4.6 .2c-1.5-.4-2.9-.9-4.3-1.5c-2.8-1.2-3.7-1.6-5.6-2.4l-.1 0c-12.8-5.6-24.7-13.2-35.2-22.4c-2.8-2.5-5.4-5.2-8.1-7.8c-8.8-8.4-16.5-18-22.8-28.4l-1.3-2.1c-.9-1.4-1.7-3-2.3-4.6c-.9-3.3 1.4-5.9 1.4-5.9s5.4-6 8-9.2c2.1-2.7 4.1-5.5 5.9-8.4c2.6-4.3 3.5-8.6 2.1-12c-6.3-15.3-12.8-30.6-19.4-45.7c-1.3-3-5.2-5.2-8.8-5.6c-1.2-.1-2.4-.3-3.6-.4c-3-.1-6-.1-9 .1z'
      
    ]
  };

  

  
  

  var faYoutube = {
    prefix: 'fak',
    iconName: 'youtube',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M470.6 147.9c-5.2-19.4-20.3-34.7-39.6-39.8c-34.9-9.4-175-9.4-175-9.4s-140.1 0-175 9.4c-19.3 5.2-34.5 20.5-39.6 39.8C32 183 32 256.3 32 256.3s0 73.3 9.4 108.5c5.2 19.4 20.3 34 39.6 39.2c34.9 9.4 175 9.4 175 9.4s140.1 0 175-9.4c19.3-5.2 34.5-19.8 39.6-39.2c9.4-35.1 9.4-108.5 9.4-108.5s0-73.3-9.4-108.5zm-260.5 175V189.7l117.1 66.6L210.2 322.9z'
      
    ]
  };

  



export {

  faAvancar10s,
  

  faFacebookF,
  

  faHorizontal,
  

  faInstagram,
  

  faInstagramSolid,
  

  faLinkedinSolid,
  

  faLogoHero,
  

  faPictureInPicture,
  

  faTiktokSolid,
  

  faTwitterSolid,
  

  faVertical,
  

  faVideoSpeed,
  

  faVoltar10s,
  

  faWhatsapp,
  

  faWhatsappSolid,
  

  faYoutube,
  

};
